module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/october-3fdbfd07903e034b3041cb4837707454.png";